import {
  EVOLUTION_TYPE_SERVICE,
  EVOLUTION_TYPE_TEXT,
} from "./constants";

/**
 * Confirma appointmentType de evolução (filtro client-side).
 * Aceita code EVOLUTION ou text "Evolução" — mesmo espírito de isProntoAtendimentoAppointment.
 */
export function isEvolutionAppointment(
  appointment: fhir5.Appointment | undefined,
): boolean {
  if (!appointment) return false;

  const codingCode = appointment.appointmentType?.coding?.[0]?.code || "";
  const text = appointment.appointmentType?.text || "";

  return (
    codingCode === EVOLUTION_TYPE_SERVICE ||
    text === EVOLUTION_TYPE_SERVICE ||
    text === EVOLUTION_TYPE_TEXT
  );
}
